<div class="buyer-section">
    <div class="heading">
        <div class="ipm-close-icon" (click)="closePopOver(true)">
            <i class="pi pi-times"></i>
        </div>
         <div class="profile-div">
              <img priority [src]="data.image" [class.is-empty]="!data.image" (error)="browserStorage.errorHandler($event, 'userIcon')" alt="buyer-image" loading="lazy">
         </div>
         <div class="buyer-name">
             {{data.name}}
         </div>
    </div>
    <div class="buyer-body">
        <div class="list">
            <span class="heading">
                <span class="sub-head">Name</span>
                <span class="icon">:</span>
            </span>
            <span class="name">{{data.name}}</span>
        </div>
        <div class="list">
            <span class="heading">
                <span class="sub-head">Email</span>
                <span class="icon">:</span>
            </span>
            <span class="name">{{data.email}}</span>
        </div>
    </div>
</div>
